import React from 'react';
import { MENU_ICON_PATHS } from './menuIcons';
import { openFeedbackModal } from '../utils/feedbackModal';

interface HeaderUtilityMenuProps {
  onSignOut: () => void;
  includeExportPolicy?: boolean;
  onExportPolicy?: () => void;
}

const HeaderUtilityMenu: React.FC<HeaderUtilityMenuProps> = ({ onSignOut, includeExportPolicy = false, onExportPolicy }) => {
  const [open, setOpen] = React.useState(false);
  const wrapperRef = React.useRef<HTMLDivElement | null>(null);

  const renderMenuItem = (
    label: string,
    iconPath: string,
    onClick: () => void,
    isDanger = false
  ) => (
    <button
      type="button"
      onClick={onClick}
      className="traffic-menu-font w-full text-left px-3 py-2 rounded-md text-[14px] transition-colors hover:bg-gray-100"
      style={{
        color: isDanger ? '#b91c1c' : '#1f2937',
        fontWeight: isDanger ? 600 : 500,
        display: 'inline-flex',
        alignItems: 'center',
        gap: '10px'
      }}
    >
      <img src={iconPath} alt="" style={{ width: '16px', height: '16px', objectFit: 'contain' }} />
      <span>{label}</span>
    </button>
  );

  React.useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (!wrapperRef.current) return;
      if (!wrapperRef.current.contains(event.target as Node)) {
        setOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <div ref={wrapperRef} style={{ position: 'relative', flexShrink: 0 }}>
      <button
        type="button"
        aria-label="Open utility menu"
        title="Open utility menu"
        onClick={() => setOpen((prev) => !prev)}
        style={{
          width: '42px',
          height: '42px',
          borderRadius: '9999px',
          border: '1px solid #d1d5db',
          backgroundColor: '#ffffff',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          cursor: 'pointer',
          boxShadow: '0 2px 8px rgba(0,0,0,0.08)'
        }}
      >
        <img src={MENU_ICON_PATHS.more} alt="" style={{ width: '18px', height: '18px', objectFit: 'contain' }} />
      </button>

      {open && (
        <div
          style={{
            position: 'absolute',
            right: 0,
            top: 'calc(100% + 8px)',
            minWidth: '190px',
            borderRadius: '10px',
            border: '1px solid #d1d5db',
            backgroundColor: '#ffffff',
            boxShadow: '0 8px 22px rgba(0,0,0,0.14)',
            zIndex: 1000,
            padding: '8px'
          }}
        >
          {renderMenuItem('About', MENU_ICON_PATHS.about, () => {
            setOpen(false);
            window.open('https://www.trafficliteedu.com/', '_blank', 'noopener,noreferrer');
          })}
          {renderMenuItem('Report an Issue', MENU_ICON_PATHS.reportIssue, () => {
            setOpen(false);
            openFeedbackModal({ initialStep: 'issue' });
          })}
          {renderMenuItem('Suggest a Feature', MENU_ICON_PATHS.suggestFeature, () => {
            setOpen(false);
            openFeedbackModal({ initialStep: 'feature' });
          })}
          {includeExportPolicy && renderMenuItem('Export Policy to PDF', MENU_ICON_PATHS.export, () => {
            setOpen(false);
            onExportPolicy?.();
          })}
          {renderMenuItem('Sign Out', MENU_ICON_PATHS.signOut, () => {
            setOpen(false);
            onSignOut();
          }, true)}
        </div>
      )}
    </div>
  );
};

export default HeaderUtilityMenu;
